import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemoryControllerUpdateMutationRequest, AgentMemoryControllerUpdateMutationResponse, AgentMemoryControllerUpdatePathParams, AgentMemoryControllerUpdate400, AgentMemoryControllerUpdate401, AgentMemoryControllerUpdate403, AgentMemoryControllerUpdate404 } from "../../models/agentMemoriesController/AgentMemoryControllerUpdate";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { agentMemoryControllerUpdate } from "../../clients/agent-memoriesService/agentMemoryControllerUpdate";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const agentMemoryControllerUpdateMutationKey = () => [{
  url: '/api/v1/agent-memories/:id'
}] as const;
export type AgentMemoryControllerUpdateMutationKey = ReturnType<typeof agentMemoryControllerUpdateMutationKey>;
export function agentMemoryControllerUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AgentMemoryControllerUpdateMutationRequest>> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = agentMemoryControllerUpdateMutationKey();
  return mutationOptions<AgentMemoryControllerUpdateMutationResponse, ResponseErrorConfig<AgentMemoryControllerUpdate400 | AgentMemoryControllerUpdate401 | AgentMemoryControllerUpdate403 | AgentMemoryControllerUpdate404>, {
    id: AgentMemoryControllerUpdatePathParams["id"];
    data?: AgentMemoryControllerUpdateMutationRequest;
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      id,
      data
    }) => {
      return agentMemoryControllerUpdate(id, data, config);
    }
  });
}

/**
 * @summary Update an AI agent memory profile
 * {@link /api/v1/agent-memories/:id}
 */
export function useAgentMemoryControllerUpdate(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? agentMemoryControllerUpdateMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = agentMemoryControllerUpdateMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<AgentMemoryControllerUpdateMutationResponse, ResponseErrorConfig<AgentMemoryControllerUpdate400 | AgentMemoryControllerUpdate401 | AgentMemoryControllerUpdate403 | AgentMemoryControllerUpdate404>, {
    id: AgentMemoryControllerUpdatePathParams["id"];
    data?: AgentMemoryControllerUpdateMutationRequest;
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<AgentMemoryControllerUpdateMutationResponse, ResponseErrorConfig<AgentMemoryControllerUpdate400 | AgentMemoryControllerUpdate401 | AgentMemoryControllerUpdate403 | AgentMemoryControllerUpdate404>, {
    id: AgentMemoryControllerUpdatePathParams["id"];
    data?: AgentMemoryControllerUpdateMutationRequest;
  }, TContext>;
}